import { useQuery } from "@tanstack/react-query";
import { auditLogApi, AuditLogFilters } from "@/services/auditLogApi";

export function useAuditLog(projectId: string | undefined, filters?: AuditLogFilters) {
  return useQuery({
    queryKey: ["projects", projectId, "audit-log", filters ?? {}],
    queryFn: () => auditLogApi.getAuditLog(projectId, filters),
    enabled: !!projectId,
  });
}
